import { PureComponent, type ReactNode, StrictMode } from "react";

export class ReviewItemSkeleton extends PureComponent {
  render(): ReactNode {
    return (
      <StrictMode>
        <div className="animate-pulse mb-10">
          <div className="flex items-center mb-1">
            <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md" />
          </div>
          <div>
            <div className="w-full bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-full bg-black-300 h-6 mb-2 rounded-md" />
            <div className="w-full bg-black-300 h-6 mb-2 rounded-md" />
          </div>
        </div>
      </StrictMode>
    );
  }
}
